/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';

const styles = {
  media: {
    height: 0,
    paddingTop: '25%',
  },
};

const MAX_IMG_WIDTH = 2400;

const ImagePreview = ({ classes, record }) => {
  const windowWidth = window.innerWidth;
  let imageSrc;
  if (record.rawFile) {
    imageSrc = record.imageUrl;
  } else {
    imageSrc = record;
  }

  if (!imageSrc) {
    return null;
  }

  if (!record.rawFile && windowWidth < MAX_IMG_WIDTH) {
    imageSrc = `${imageSrc}?width=${windowWidth}`;
  }

  return (
    <Card className={classes.card}>
      <CardMedia className={classes.media} image={imageSrc} />
    </Card>
  );
};

export default withStyles(styles)(ImagePreview);
